import React, {memo} from "react";
import { Link } from "react-router-dom";
import BukkuTooltip from "../../../../Tooltip";

function Name({ text, record, getUrlFn }) {
    const component = (
        <BukkuTooltip title={text}>
            <span
                className="ellipsis-div"
                style={{ display: "block" }}
            >
                <span style={{ fontSize: "13px" }}>{text}</span>
            </span>
        </BukkuTooltip>
    );

    return (
        <Link
            to={getUrlFn(record, record.column_type)}
            style={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            }}
        >
            {component}
        </Link>
    );
}

export default memo(Name);
